import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import FONT_FAMILY from '../../../constants/fontFamily';
import FontFamilyHeader from '../../FontFamilyHeader';
import { Container, Image, Text } from './styles';

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function MediaLoopSimple({ data }) {
  const [mediaIndex, setMediaIndex] = useState(
    data.isManual ? data.fileIndex || 0 : 0
  );
  const [show, setShow] = useState(data.isManual ? false : true);
  const [showContainer, setShowContainer] = useState(
    data.isManual ? false : true
  );
  const continueAnimation = useRef(true);

  const startAnimation = async () => {
    let isEndLoop = false;
    await sleep(data.duration * 1000);
    setShow(false);
    await sleep(950);
    setShowContainer(false);
    await sleep(50);
    setMediaIndex((prevIndex) => {
      if (prevIndex + 1 >= data.files.length) {
        isEndLoop = true;
        return 0;
      }
      return prevIndex + 1;
    });
    if (isEndLoop) {
      await sleep(data.delayEnd * 1000);
    } else {
      await sleep(data.delayBetween * 1000);
    }
    setShow(true);
    setShowContainer(true);
    if (!continueAnimation.current) return;
    startAnimation();
  };

  const changeManual = async () => {
    setShow(false);
    await sleep(950);
    setShowContainer(false);
    await sleep(50);
    setMediaIndex(data.fileIndex);
    setShow(true);
    setShowContainer(true);
  };

  useEffect(() => {
    if (data.isManual) {
      continueAnimation.current = false;
      changeManual();
      return;
    }
    continueAnimation.current = true;
    startAnimation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.isManual, data.fileIndex]);

  const textComponent = () => {
    const fontFamily =
      FONT_FAMILY[data?.files?.[mediaIndex]?.styles?.family || 'notoSans'];

    return (
      <>
        <FontFamilyHeader family={fontFamily} />
        <Text
          hasText={data?.files?.[mediaIndex]?.hasText}
          style={{
            color: data?.files?.[mediaIndex]?.styles?.color,
            fontFamily: fontFamily.family,
            fontSize: data?.files?.[mediaIndex]?.styles?.size,
            lineHeight: data?.files?.[mediaIndex]?.styles?.size
              ? `${data?.files?.[mediaIndex]?.styles?.size + 10}px`
              : undefined,
            left: data?.files?.[mediaIndex]?.styles?.x,
            top: data?.files?.[mediaIndex]?.styles?.y,
          }}
        >
          {data?.files?.[mediaIndex]?.value}
        </Text>
      </>
    );
  };

  return (
    showContainer && (
      <Container
        animation={data.animation}
        isText={data?.files?.[mediaIndex]?.isText}
        show={show}
      >
        {data?.files?.[mediaIndex]?.isImage && (
          <>
            {data?.files?.[mediaIndex]?.hasText && textComponent()}
            <Image src={data?.files?.[mediaIndex]?.url} />
          </>
        )}
        {data?.files?.[mediaIndex]?.isText && textComponent()}
      </Container>
    )
  );
}

MediaLoopSimple.propTypes = {
  data: PropTypes.shape({
    animation: PropTypes.string,
    delayBetween: PropTypes.number,
    delayEnd: PropTypes.number,
    duration: PropTypes.number,
    fileIndex: PropTypes.number,
    isManual: PropTypes.bool,
    files: PropTypes.arrayOf(
      PropTypes.shape({
        hasText: PropTypes.bool,
        isImage: PropTypes.bool,
        isText: PropTypes.bool,
        url: PropTypes.string,
        value: PropTypes.string,
        styles: PropTypes.shape({
          color: PropTypes.string,
          family: PropTypes.string,
          size: PropTypes.number,
          y: PropTypes.number,
          x: PropTypes.number,
        }),
      })
    ),
  }),
};

MediaLoopSimple.defaultProps = {
  data: {
    animation: 'fade',
    delayBetween: 1,
    delayEnd: 5,
    duration: 5,
    fileIndex: 0,
    isManual: false,
    files: [],
  },
};

export default MediaLoopSimple;
